import { render, staticRenderFns } from "./blockchainNetworks.vue?vue&type=template&id=3817a5d7&scoped=true"
import script from "./blockchainNetworks.vue?vue&type=script&lang=js"
export * from "./blockchainNetworks.vue?vue&type=script&lang=js"
import style0 from "./blockchainNetworks.vue?vue&type=style&index=0&id=3817a5d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3817a5d7",
  null
  
)

export default component.exports